( function () {
	'use strict';

	// Leert das Alert-Element zuerst, dann setzt neuen Text –
	// so wird dieselbe Nachricht bei Wiederholung erneut vorgelesen.
	function announce( alertEl, message ) {
		alertEl.textContent = '';
		requestAnimationFrame( () => {
			requestAnimationFrame( () => {
				alertEl.textContent = message;
			} );
		} );
	}

	function updateBlock( block, data ) {
		const ts = block.querySelector( '.parking-occupancy-overview__timestamp' );
		if ( ts ) ts.textContent = 'Stand: ' + data.timestamp;

		block.querySelectorAll( '[data-cleverciti-id]' ).forEach( ( item ) => {
			const entry = data.entries[ item.dataset.clevercitiId ];
			if ( ! entry ) return;

			const widget = item.querySelector( '.cleverciti-parking' );
			if ( ! widget ) return;

			if ( ! entry.is_open ) {
				widget.className =
					'cleverciti-parking cleverciti-parking--unavailable cleverciti-parking--detail';

				const occupancyEl = widget.querySelector( '.cleverciti-detail__occupancy' );
				const capacityEl  = widget.querySelector( '.cleverciti-detail__capacity' );
				const freeEl      = widget.querySelector( '.cleverciti-detail__free' );
				const labelEl     = widget.querySelector( '.cleverciti-detail__label' );

				if ( occupancyEl ) occupancyEl.textContent = '—';
				if ( capacityEl )  capacityEl.textContent  = '—';
				if ( freeEl )      freeEl.textContent       = '';
				if ( labelEl )     labelEl.textContent       = '';

				if ( ! widget.querySelector( '.cleverciti-closed' ) ) {
					const closed       = document.createElement( 'span' );
					closed.className   = 'cleverciti-closed';
					closed.textContent = 'Geschlossen';
					widget.appendChild( closed );
				}
				return;
			}

			// Parkfläche geöffnet: Daten aktualisieren
			widget.className =
				`cleverciti-parking cleverciti-parking--${ entry.color } cleverciti-parking--detail`;

			const occupancyEl = widget.querySelector( '.cleverciti-detail__occupancy' );
			const capacityEl  = widget.querySelector( '.cleverciti-detail__capacity' );
			const freeEl      = widget.querySelector( '.cleverciti-detail__free' );
			const labelEl     = widget.querySelector( '.cleverciti-detail__label' );
			const closedEl    = widget.querySelector( '.cleverciti-closed' );

			if ( occupancyEl ) occupancyEl.textContent = String( entry.occupancy );
			if ( capacityEl )  capacityEl.textContent  = String( entry.capacity );
			if ( freeEl )      freeEl.textContent       = ' (noch ' + entry.free + ' frei)';
			if ( labelEl )     labelEl.textContent       = ' Plätzen belegt';
			if ( closedEl )    closedEl.remove();
		} );
	}

	async function refreshBlock( btn ) {
		const block   = btn.closest( '.parking-occupancy-overview-block' );
		const alertEl = block.querySelector( '.parking-refresh-status' );

		btn.disabled = true;
		btn.setAttribute( 'aria-busy', 'true' );
		btn.textContent = 'Wird aktualisiert…';

		const controller = new AbortController();
		const timeout    = setTimeout( () => controller.abort(), 15000 );

		try {
			const response = await fetch( btn.dataset.ajaxUrl, {
				method:  'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body:    new URLSearchParams( {
					action: 'cdh_parking_refresh',
					nonce:  btn.dataset.nonce,
				} ).toString(),
				signal: controller.signal,
			} );

			if ( ! response.ok ) throw new Error( 'HTTP ' + response.status );

			const json = await response.json();

			if ( json.success ) {
				updateBlock( block, json.data );
				announce( alertEl, 'Belegungsdaten wurden aktualisiert.' );
			} else {
				announce(
					alertEl,
					'Aktualisierung fehlgeschlagen: ' + ( json.data?.message ?? 'Unbekannter Fehler.' )
				);
			}
		} catch ( err ) {
			announce(
				alertEl,
				err.name === 'AbortError'
					? 'Zeitüberschreitung – bitte erneut versuchen.'
					: 'Verbindungsfehler – bitte erneut versuchen.'
			);
		} finally {
			clearTimeout( timeout );
			btn.disabled = false;
			btn.removeAttribute( 'aria-busy' );
			btn.textContent = 'Daten aktualisieren';
		}
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		document.querySelectorAll(
			'.parking-occupancy-overview-block .parking-refresh-btn'
		).forEach( ( btn ) => {
			btn.addEventListener( 'click', () => refreshBlock( btn ) );
		} );
	} );
} )();
